import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import emptyInvoice from "../../assets/images/empty-invoice.png";
import AddButton from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "../../components/tables/dynamic-table1";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import moment from "moment";
import { customerDeleteAction } from "../../redux/actions/customer-action";
import CustomerFilter from "../../components/tables/table-filter/customer-filter";
import { partyTypeFilterOptions } from "../../components/helper-components/data";
import { DataContext } from "../../components/layouts/main-layout";
import { adminCustomerTableAction } from "../../redux/actions/admin-customer-action";
import {
  ArrowDown,
  ArrowUp,
  ChartColumnIncreasing,
  FileText,
  Minus,
  MoveDownLeft,
  Plus,
  TimerIcon,
} from "lucide-react";
import TransSummaryComp from "../../components/helper-components/trans-summary-comp";
import ActiveIcon from "../../assets/icons/admin-customer-icons/statistics-icons/active-icon";
import NewIcon from "../../assets/icons/admin-customer-icons/statistics-icons/new-icon";
import RsIcon from "../../assets/icons/admin-customer-icons/statistics-icons/Rs-icon";
import TotalIcon from "../../assets/icons/admin-customer-icons/statistics-icons/total-icon";
import DynamicTransactionTable from "../../components/tables/dynamic-transaction-table";

const AdminCustomerTable = () => {
  const [heading, setHeading] = useState([]);

  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [statistics, setStatistics] = useState(null);

  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "cmr_phone_number",
    from: "",
    to: "",
    inputValue: "",
    customer_status: "",
    party_types: [],
  });
  useEffect(() => {
    dispatch(
      adminCustomerTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );

    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const cusData = parsed.find((obj) => obj?.party_list);
      if (cusData?.party_list) {
        const updatedHeading = cusData.party_list.map((col) =>
          col?.value === "cmr_type"
            ? { ...col, label: "Business Associations", display: false, column: false }
            : col
        );
        setHeading(updatedHeading);
      }
    }
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setCustomers(data?.data?.customerList);
    setDataCount(data?.data?.totalCount);
    setStatistics(data?.data?.customerStats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const tableBodyData = customers?.map((item) => {
    const partyType = partyTypeFilterOptions
      .filter((opt) => item?.[opt.value])
      .map((opt) => opt.label)
      .join(",");
    return {
      id: item?.cmr_id,
      cmr_code:
        <span className="fw_500">{item?.cmr_code ?? "--"}</span> ?? "--",
      cmr_first_name: item?.cmr_first_name ? item?.cmr_first_name : "--",
      cmr_type: partyType || "--",
      is_corporate_cmr: item?.is_corporate_cmr,

      cmr_party_category: item?.cmr_party_category
        ? item?.cmr_party_category
        : "--",
      cmr_active_from:
        item?.cmr_active_from !== null
          ? moment(item?.cmr_active_from).format("DD-MM-YYYY")
          : "--",
      cmr_last_activity:
        item?.cmr_last_activity !== null
          ? moment(item?.cmr_last_activity).format("DD-MM-YYYY")
          : "--",
      total_order_value: "₹ " + item?.total_order_value,
      cmr_order_status: item?.total_order_value > 0 ? "Active" : "Inactive",

      created_date: moment(item?.created_date).format("DD-MM-YYYY"),
      created_user_name: item?.created_user_name ? item?.created_user_name : "--",
      updated_user_name: item?.updated_user_name ? item?.updated_user_name : "--",
      store_code: item?.store_code ? item?.store_code : "--",
      store_name: item?.store_name ? item?.store_name : "--",
      store_type: item?.store_type ? item?.store_type : "--",
      firm_name: item?.firm_name ? item?.firm_name : "--",
    };
  });
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <CustomerFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setShowFilter={setShowFilter}
    />
  ) : null;

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Parties",
      value: statistics?.current_total_parties ?? 0,
      desc: (
        <span className="flex gap-[3px]">
          {" "}
          {statistics?.total_parties_change_pct >= 0 ? (
            <ArrowUp size={15} strokeWidth={2} />
          ) : (
            <ArrowDown size={15} strokeWidth={2} />
          )}
          <span className="flex align-center justify-center">
            <span className="flex items-center">
              {statistics?.total_parties_change_pct >= 0 ? (
                <Plus size={10} strokeWidth={3} />
              ) : (
                <Minus size={10} strokeWidth={3} />
              )}
            </span>
            <span>
              {" "}
              {statistics?.total_parties_change_pct || 0}% vs last month
            </span>
          </span>{" "}
        </span>
      ),
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <TotalIcon size={16} color="var(--trans-stats-con-green-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "New Parties",
      value: statistics?.current_new_parties ?? 0,

      desc: (
        <span className="flex gap-[3px]">
          {" "}
          {statistics?.new_parties_change_pct >= 0 ? (
            <ArrowUp size={15} strokeWidth={2} />
          ) : (
            <ArrowDown size={15} strokeWidth={2} />
          )}
          <span className="flex align-center justify-center">
            <span className="flex items-center">
              {statistics?.new_parties_change_pct >= 0 ? (
                <Plus size={10} strokeWidth={3} />
              ) : (
                <Minus size={10} strokeWidth={3} />
              )}
            </span>
            <span>
              {" "}
              {statistics?.new_parties_change_pct || 0}% vs last month
            </span>
          </span>
        </span>
      ),

      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: <NewIcon size={16} color="var(--trans-stats-con-orange-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Active Parties",
      value: statistics?.current_active_parties ?? 0,

      desc: (
        <span className="flex gap-[3px]">
          {" "}
          {statistics?.active_parties_percentage >= 0 ? (
            <ArrowUp size={15} strokeWidth={2} />
          ) : (
            <ArrowDown size={15} strokeWidth={2} />
          )}
          <span>
            {`${statistics?.active_parties_percentage || 0} of total parties`}
          </span>{" "}
        </span>
      ),

      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <ActiveIcon size={16} color="var(--trans-stats-con-blue-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-violet2-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg Transaction Value ",
      value: `₹${statistics?.current_avg_transaction_value ?? 0}`,

      desc: (
        <span className="flex gap-[3px]">
          {" "}
          {statistics?.avg_transaction_change_pct >= 0 ? (
            <ArrowUp size={15} strokeWidth={2} />
          ) : (
            <ArrowDown size={15} strokeWidth={2} />
          )}
          <span className="flex align-center justify-center">
            <span className="flex items-center">
              {statistics?.avg_transaction_change_pct >= 0 ? (
                <Plus size={10} strokeWidth={3} />
              ) : (
                <Minus size={10} strokeWidth={3} />
              )}
            </span>
            <span>
              {" "}
              {statistics?.avg_transaction_change_pct || 0}% vs last month
            </span>
          </span>
        </span>
      ),

      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-voilet2-fg)]",
      icon: <RsIcon size={16} color="var(--trans-stats-con-voilet2-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );
  console.log("permissionFn", permissionFn);
  return (
    <InnerLayout
      backBtn={true}
      list={true}
      onclkFn={() => navigate("/admin/add-customer")}
      title="Party List"
      module=""
      permissionFn={true}
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : customers?.length === 0 ? (
        <div className="flex flex-col justify-center items-center h-full">
          <div>
            <img src={emptyInvoice} alt="empty-invoice" />
            <h3 className="flex justify-center color-000000 fw_600 fs_18">
              No customers found{" "}
            </h3>
            <p className="flex justify-center color-6C7184 fw_400 mt-4 fs_14">
              Let’s start by adding your first customer.{" "}
            </p>
            <div className="flex justify-center mt-3">
              <AddButton
                text="Add Customer"
                onclkFn={() => navigate("/add-customer")}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <DynamicTransactionTable
            actionsPermissions={{
              edit: ["Inactive"],
              delete: ["Inactive"],
            }}
            is_checkbox_req={false}
            onClickItemFn={(id) => {
              localStorage.removeItem("customerAdmin");
              navigate(`/admin/view-customer/${id}`);
            }}
            list={true}
            onclkFn={() => {
              localStorage.removeItem("customerAdmin");
              navigate("/admin/add-customer");
            }}
            transactionKey="cmr"
            permissionFn={permissionFn}
            module={"customer"}
            path="customer-admin"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={customerDeleteAction}
            label="Customer"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "cmr_phone_number",
              from: "",
              to: "",
              inputValue: "",
              customer_status: "",
              party_types: [],
            }}
            summaryArray={summaryArray}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default AdminCustomerTable;

const tableHeading = [
  {
    label: "Party ID",
    value: "cmr_code",
    display: false,
    column: true,
  },
  {
    label: "Party Name",
    value: "cmr_first_name",
    display: true,
    column: true,
  },
  { label: "Business Associations", value: "cmr_type", display: false, column: false },
  { label: "ACTIVE FROM", value: "created_date", display: true, column: false },
  {
    label: "TOTAL SALE AMOUNT",
    value: "total_order_value",
    display: true,
    column: false,
  },
  { label: "", value: "", column: false },
];

const category = {
  "01K24NE68PEWXRE5VPYGK0JCXR": "Individual",
};
